import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ResultOfT, Result } from 'src/app/shared/models/response/result';
import { HolidayResponse } from 'src/app/shared/models/response/appointment/available-slots';
import { BaseService } from 'src/app/shared/services/base.service';
import { WebStorageService } from '../../shared/services/web-storage.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayService extends BaseService {
  private currentTabIndex: number = 0;

  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  // Tab management methods
  public setTabIndex(tabIndex: number): void {
    this.currentTabIndex = tabIndex;
  }

  public getTabIndex(): number {
    return this.currentTabIndex;
  }

  // For backward compatibility
  public _setTabIndex(tabIndex: number): void {
    this.setTabIndex(tabIndex);
  }

  public _getTabIndex(): number {
    return this.getTabIndex();
  }

  // Holiday CRUD operations
  public getAllHolidays(): Observable<ResultOfT<HolidayResponse[]>> {
    return this.get<ResultOfT<HolidayResponse[]>>('Settings/GetHolidayList');
  }

  public getHolidaysByYear(year: number): Observable<ResultOfT<HolidayResponse[]>> {
    return this.get<ResultOfT<HolidayResponse[]>>(`Settings/GetHolidayByYear/${year}`);
  }

  public GetHolidayById(appHolidayId: number): Observable<ResultOfT<HolidayResponse>> {
    return this.get<ResultOfT<HolidayResponse>>(`Settings/GetHolidayById/${appHolidayId}`);
  }

  public AddHoliday(holidayResponseModel: HolidayResponse): Observable<Result> {
    return this.post<Result>('Settings/AddHoliday', holidayResponseModel);
  }

  public UpdateHoliday(holidayResponseModel: HolidayResponse): Observable<Result> {
    return this.post<Result>('Settings/UpdateHoliday', holidayResponseModel);
  }

  public deleteHoliday(appHolidayId: number): Observable<ResultOfT<boolean>> {
    return this.get<ResultOfT<boolean>>(`Settings/DeleteHoliday/${appHolidayId}`);
  }

  // Holiday utility operations
  public copyPreviousYearHoliday(fromYear: number, toYear: number, isOverride: boolean, holidayIds: string): Observable<ResultOfT<HolidayResponse[]>> {
    return this.get<ResultOfT<HolidayResponse[]>>(`Settings/CopyPreviousYearHoliday/${fromYear}/${toYear}/${isOverride}/${holidayIds}`);
  }
}
